
const HYPERVERGE_STATE = {
  INIT: "INIT",
  KYC: "KYC",
  USER_VERIFIED: "USER_VERIFIED",
}

export { HYPERVERGE_STATE };
